// 搜索功能模块
export class SearchManager {
    constructor() {
        this.searchInput = document.getElementById('searchInput');
        this.noResultsMessage = document.getElementById('noResultsMessage');
        this.init();
    }

    init() {
        if (this.searchInput) {
            this.searchInput.addEventListener('input', (e) => this.handleSearch(e));
        }
    }

    handleSearch(e) {
        const searchText = e.target.value.toLowerCase().trim();
        const cards = document.querySelectorAll('.link-card');
        let visibleCardsCount = 0;

        cards.forEach(card => {
            const link = card.querySelector('a');
            const title = link.textContent.toLowerCase();
            const description = card.querySelector('.card-text').textContent.toLowerCase();
            const href = link.getAttribute('href').toLowerCase();
            const searchContent = `${title} ${description} ${href}`;

            // 支持空格分隔的多个关键词搜索
            const keywords = searchText.split(/\s+/).filter(k => k.length > 0);
            const matchesAll = keywords.length === 0 || keywords.every(keyword =>
                searchContent.includes(keyword)
            );

            if (matchesAll) {
                card.classList.remove('hidden');
                card.style.display = '';
                visibleCardsCount++;
            } else {
                card.classList.add('hidden');
                // 使用setTimeout实现平滑过渡
                setTimeout(() => {
                    if (card.classList.contains('hidden')) {
                        card.style.display = 'none';
                    }
                }, 200);
            }
        });

        // 处理空分类的显示
        this.handleCategoryVisibility();

        // 显示或隐藏"无结果"提示
        this.handleNoResultsMessage(searchText, visibleCardsCount);
    }

    handleCategoryVisibility() {
        document.querySelectorAll('.category-header').forEach(header => {
            const section = header.closest('.category-section');
            const group = header.nextElementSibling;
            const visibleCards = group.querySelectorAll('.link-card:not(.hidden)').length;

            if (section) {
                if (visibleCards > 0) {
                    section.style.display = '';
                    section.style.opacity = '1';
                } else {
                    section.style.opacity = '0';
                    setTimeout(() => {
                        if (parseInt(section.style.opacity) === 0) {
                            section.style.display = 'none';
                        }
                    }, 300);
                }
            }
        });
    }

    handleNoResultsMessage(searchText, visibleCardsCount) {
        if (this.noResultsMessage) {
            if (searchText.length > 0 && visibleCardsCount === 0) {
                this.noResultsMessage.classList.remove('d-none');
            } else {
                this.noResultsMessage.classList.add('d-none');
            }
        }
    }
}

// 初始化搜索功能
document.addEventListener('DOMContentLoaded', () => {
    new SearchManager();
});
